import { twMerge, twJoin } from 'tailwind-merge';
import {
  datoCMSMaterialIcons,
  getCounterDigit,
  isCustomSvgIcon,
  customSvgIcons,
  shouldFillIcon,
  isCounterIcon,
} from '@/utils/icons';

type Props = { className?: string; icon: string };

const B2BIcon = ({ className, icon }: Props) => {
  const resolvedIcon = datoCMSMaterialIcons[icon] ?? icon;

  return (
    <span className={twMerge('b2b-icon', className)} aria-hidden="true">
      {isCustomSvgIcon(icon) ? (
        customSvgIcons[icon]
      ) : isCounterIcon(resolvedIcon) ? (
        <span className="b2b-icon-digit">{getCounterDigit(resolvedIcon)}</span>
      ) : (
        <span className={twJoin('material-symbols-outlined', shouldFillIcon(icon) && 'b2b-icon-filled')}>
          {resolvedIcon}
        </span>
      )}
    </span>
  );
};

export default B2BIcon;
